import request from 'services/api'

const api = {
    getCleaningHistory: (startdate, enddate) => {
        return request
            .get(`/schonen-historie?startdate=${startdate}&enddate=${enddate}`)
            .responseType('json')
    }
}

export default api
